module.exports = __webpack_public_path__ + "static/media/Twitter.6763fe84.svg";